// extracted by mini-css-extract-plugin
export default {"badgeList":"Badge_badgeList__Ci3CL","badgeIcon":"Badge_badgeIcon__9dAbZ"};